var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_39",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6107",
    "data-name": "Group 6107",
    transform: "translate(-65 -712)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 65, 712)",
    filter: "url(#Ellipse_39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39-2",
    "data-name": "Ellipse 39",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(9 5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_003-whatsapp",
    "data-name": "003-whatsapp",
    transform: "translate(77.903 720.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18196",
    "data-name": "Path 18196",
    d: "M.346,16.264a.346.346,0,0,1-.334-.437L1.07,11.965A8.065,8.065,0,1,1,8.129,16.13h0a8.08,8.08,0,0,1-3.731-.916L.434,16.252A.348.348,0,0,1,.346,16.264Zm0,0",
    transform: "translate(0)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18197",
    "data-name": "Path 18197",
    d: "M10.895,26.466l1.095-4a7.718,7.718,0,1,1,6.688,3.865h0a7.712,7.712,0,0,1-3.688-.939ZM15.175,24l.234.139a6.406,6.406,0,0,0,3.265.894h0a6.414,6.414,0,1,0-5.434-3.006l.153.243-.648,2.366Zm0,0",
    transform: "translate(-10.548 -10.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18198",
    "data-name": "Path 18198",
    d: "M19.344,34.415l1.057-3.86a7.451,7.451,0,1,1,6.456,3.731h0a7.45,7.45,0,0,1-3.56-.907Zm0,0",
    transform: "translate(-18.729 -18.767)",
    fill: "#64b161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6116",
    "data-name": "Group 6116",
    transform: "translate(0.346 0.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18199",
    "data-name": "Path 18199",
    d: "M10.895,26.466l1.095-4a7.718,7.718,0,1,1,6.688,3.865h0a7.712,7.712,0,0,1-3.688-.939ZM15.175,24l.234.139a6.406,6.406,0,0,0,3.265.894h0a6.414,6.414,0,1,0-5.434-3.006l.153.243-.648,2.366Zm0,0",
    transform: "translate(-10.895 -10.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18200",
    "data-name": "Path 18200",
    d: "M134.438,141.951c-.144-.321-.3-.328-.434-.333-.112,0-.241,0-.37,0a.709.709,0,0,0-.514.241,2.162,2.162,0,0,0-.675,1.608,3.751,3.751,0,0,0,.788,1.995,7.916,7.916,0,0,0,3.294,2.911c1.629.642,1.961.515,2.314.483a1.948,1.948,0,0,0,1.3-.917,1.611,1.611,0,0,0,.113-.917c-.048-.08-.177-.129-.37-.225s-1.141-.563-1.318-.627-.305-.1-.434.1-.5.627-.61.756-.225.145-.418.049a5.272,5.272,0,0,1-1.551-.957,5.81,5.81,0,0,1-1.073-1.335c-.112-.193,0-.288.085-.393a5.815,5.815,0,0,0,.482-.659.355.355,0,0,0-.016-.338C134.984,143.286,134.61,142.332,134.438,141.951Zm0,0",
    transform: "translate(-128.584 -137.461)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.2361dcdaee3ca27bfbfe23d0df2220d4.svg";
export { ForwardRef as ReactComponent };